import * as React from 'react';

import Icon from 'components/atoms/Icon';

export type FigureIconPropsType = {
	categoryIcon: string;
};

const FigureIcon = ({ categoryIcon }: FigureIconPropsType) => (
	<div className="m-card__figure-icon">
		<Icon iconName={categoryIcon} />
	</div>
);

FigureIcon.displayName = 'Card(FigureIcon)';

export default FigureIcon;
